import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  content: {
    ...dFlex(),
    flexDirection: 'column',
    gap: 8,
    width: '100%',
  },
  buttons: {
    ...dFlex(),
    gap: 16,
    width: '100%',
  },
}));

export default useStyles;
